module.exports = __webpack_public_path__ + "img/ios-flash-off.d6a9695f.svg";